import {evaluateLDFlag} from 'launchdarkly/LaunchDarklyUtil';

/** Whether users can see their own AI credit usage in chat settings. */
export function isUserUsageUiEnabled(): boolean {
  return evaluateLDFlag('METERING_ENABLE_USER_USAGE_UI') === true;
}
